































































import { Component, Vue, Prop } from "vue-property-decorator";

/**
 * Utils
 */
import * as imageLinks from "@/config/image-links";
import classes from "@/config/wow/classes";

/**
 * Helpers
 */

/**
 * Mixins
 */

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * API
 */
import usersAPI from "@/api/users";

/**
 * Claim characters modal.
 */
@Component
export default class ClaimCharacterDialog extends Vue {
	$refs!: {
		modal: Dialog;
	};

	/// Injections
	imageLinks = imageLinks;
	classes = classes;

	/// Properties
	@Prop()
	onAfterClaim!: () => Promise<void>;

	/// Attributes
	isLoading = false;
	characters: any[] | null = null;

	/// Methods
	async open() {
		this.characters = null;
		this.isLoading = true;
		this.$refs.modal.open();
		await this.refreshCharacters();
		this.isLoading = false;
	}

	close() {
		this.$refs.modal.close();
	}

	async refreshCharacters() {
		const characters: any[] | null = await usersAPI.getCharacterToClaim();
		if (characters) {
			this.characters = characters;
		}
	}

	async handleClaimCharacterClick(character: any) {
		this.isLoading = true;
		try {
			await usersAPI.claimCharacter(character.region, character.realm.name, character.name);
			await this.refreshCharacters();
			if (this.onAfterClaim) {
				await this.onAfterClaim();
			}
		}
		catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}
}
